import React, { useContext, useEffect, useState } from "react";

import { Link, useLocation } from "react-router-dom";

import { Container } from "@mui/material";

import {
  Text,
  Paper,
  Avatar,
  Menu,
  rem,
  Drawer,
  Burger,
  ActionIcon,
  NavLink,
  Divider,
} from "@mantine/core";
import { useDisclosure, useViewportSize } from "@mantine/hooks";
import { IconLogout2, IconMenu3, IconUser, IconX } from "@tabler/icons-react";

import { motion } from "framer-motion";

import { routes } from "./routes";
import { Colors, LogoFull, LogoM } from "../../Lib/Data";

import "./styles.scss";
import { AppContext } from "../../Pages/Dashboard";

const Navbar: React.FC = () => {
  const context = useContext(AppContext);
  const [activeItem, setActiveItem] = useState<string>("");
  const location = useLocation();
  const { width: browserCurrentWidth } = useViewportSize();

  useEffect(() => {
    const { pathname } = location;
    const path = pathname.replaceAll("/dashboard/", "").toLowerCase();

    if (path === "/dashboard") {
      setActiveItem("");
    } else {
      routes.forEach((route) => {
        const isActive = route.link.indexOf(path.substring(0, 4)) !== -1;

        if (isActive) {
          setActiveItem(route.link);
        } else {
          // setActiveItem("");
        }
      });
    }
  }, [location]);

  const [
    isDrawerOpened,
    { open: OpenDrawer, close: CloseDrawer, toggle: ToggleDrawer },
  ] = useDisclosure(false);

  const ToggleIcon = isDrawerOpened ? IconX : IconMenu3;

  // WATCH FOR VIEWPORT CHANGES AND CLOSE DRAWER IF SCREEN IS TOO BIG
  useEffect(() => {
    if (browserCurrentWidth > 730) {
      CloseDrawer();
    }
  }, [browserCurrentWidth]);
  return (
    <>
      <Container>
        <Drawer
          size={320}
          opened={isDrawerOpened}
          onClose={CloseDrawer}
          withCloseButton={false}
        >
          <div className="small-nav flex-col">
            <Link to="/dashboard" onClick={CloseDrawer}>
              <img src={LogoFull} alt="" className="small-logo" />
            </Link>
            {routes.map((route) => {
              return (
                <Link to={`/dashboard/${route.link}`}>
                  <NavLink
                    styles={{
                      label: { color: Colors.BluePrimary },
                    }}
                    onClick={(e) => {
                      CloseDrawer();
                    }}
                    mb={10}
                    href={`/dashboard/${route.link}`}
                    label={route.label}
                    leftSection={
                      <route.icon
                        size="1rem"
                        color={Colors.BluePrimary}
                        stroke={1.5}
                      />
                    }
                  />
                </Link>
              );
            })}
            <Divider />
            <Text my={6} ml={10} fz="sm" c={Colors.GrayPrimary}>
              {context?.profile?.name}
            </Text>
            <NavLink
              styles={{
                label: { color: Colors.RedPrimary },
              }}
              onClick={context?.logout}
              label="Logout"
              leftSection={
                <IconLogout2
                  size="1rem"
                  color={Colors.RedPrimary}
                  stroke={1.5}
                />
              }
            />
          </div>
        </Drawer>
        <motion.span
          initial={false}
          animate={{
            left: isDrawerOpened ? "260px" : "30px",
          }}
          className="toggle-drawer"
        >
          <ActionIcon variant="outline" size="lg" onClick={ToggleDrawer}>
            <ToggleIcon color={Colors.BluePrimary} size={25} />
          </ActionIcon>
        </motion.span>
        <div className="nav-placeholder"></div>
        <Paper shadow="sm" mt={30} className="nav-container">
          <nav className="flex-row align-center justify-between nav-content">
            <Link to="/dashboard">
              <img src={LogoM} alt="" className="logo" />
            </Link>
            <div className="items flex-row align-center justify-between">
              {routes.map((route) => {
                return (
                  <Link to={`/dashboard/${route.link}`}>
                    <span
                      className={`item item-${
                        activeItem === route.link ? "active" : "inactive"
                      } flex-row align-center justify-center`}
                    >
                      <route.icon size={16} color={Colors.BluePrimary} />
                      <Text
                        ml={3}
                        className="label"
                        c={Colors.BluePrimary}
                        tt="capitalize"
                        fz={13.5}
                      >
                        {route.label}
                      </Text>
                    </span>
                  </Link>
                );
              })}
            </div>
            <Menu shadow="md" width={200}>
              <Menu.Target>
                <Avatar className="pointer" />
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Label>{context?.profile?.name}</Menu.Label>
                <Menu.Item
                  leftSection={
                    <IconUser
                      color={Colors.BluePrimary}
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  <Text fz={14.5} c={Colors.BluePrimary}>
                    My Profile
                  </Text>
                </Menu.Item>

                <Menu.Divider />

                <Menu.Item
                  color={Colors.RedPrimary}
                  onClick={context?.logout}
                  leftSection={
                    <IconLogout2 style={{ width: rem(14), height: rem(14) }} />
                  }
                >
                  <Text fz={14.5}>Logout</Text>
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </nav>
        </Paper>
      </Container>
    </>
  );
};

export default Navbar;
